import { Role } from 'queries/fetch/fetchTeamMembers.ts';
import { CognitoUser } from 'schemas/UserInfo.schema.ts';

export const RolesWithDescription: Record<Role, string> = {
  read: 'view campaigns and iterations',
  write: 'create and edit campaigns and iterations',
  approve: 'review iterations and summary reports',
  release: 'send iterations to NHS Notify',
  admin: 'manually export campaign configurations',
  custom_rule_admin: 'access the custom rule editor',
  cohort_admin: 'view and manage team cohorts',
  routing_plan_admin: 'view and manage message plans for the team',
  team_admin: 'view and manage users in the team',
  campaign_template_admin: 'view and manage campaign templates',
} as const;

const userHasRole = (
  user: CognitoUser,
  members: CognitoUser[],
): boolean => members.some((t) => t.sub === user?.sub);

export const getRolesForUser = (
  user: CognitoUser,
  rolesToUsers: { [r in Role]: CognitoUser[] },
) => Object.entries(RolesWithDescription)
  .filter(([role]) => userHasRole(user, rolesToUsers[role as Role] ?? []));

export const getMissingRolesForUser = (
  user: CognitoUser,
  rolesToUsers: { [r in Role]: CognitoUser[] },
) => Object.entries(RolesWithDescription)
  .filter(([role]) => !userHasRole(user, rolesToUsers[role as Role] ?? []));
